import { gsap } from 'gsap';
import debounce from 'lodash/debounce';

const mobileMenuTrigger = document.querySelector('.site-header__mobile-menu-trigger');
const menuNav = document.querySelector('.site-header__nav');
const menuLinks = document.querySelectorAll('.site-header__nav-link');
const desktopMenuBreakpoint = window.matchMedia('(min-width: 1024px)');

const resetMenu = () => {
  menuNav.removeAttribute('data-menu-active');
  gsap.set(menuNav, { clearProps: 'all' });
  gsap.set(document.body, { clearProps: 'overflow' });
};
const openMenu = () => {
  menuNav.setAttribute('data-menu-active', true);
  gsap.timeline()
    .to(menuNav, {
      autoAlpha: 1,
      duration: 0.2,
    })
    .set(document.body, { overflow: 'hidden' });
};
const closeMenu = () => {
  menuNav.removeAttribute('data-menu-active');
  gsap.timeline()
    .to(menuNav, {
      autoAlpha: 0,
      duration: 0.2,
    })
    .set(document.body, { overflow: 'auto' });
};
const toggleMenu = () => {
  if (menuNav.hasAttribute('data-menu-active')) {
    closeMenu();
  } else {
    openMenu();
  }
};

// Open/close menu.
if (mobileMenuTrigger) {
  mobileMenuTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    toggleMenu();
  });

  // Close mobile menu if you're no longer on breakpoint.
  window.addEventListener('resize', debounce(() => {
    resetMenu();
  }, 100));
}

// Close menu on link click.
Array.from(menuLinks).forEach((menuLink) => {
  menuLink.addEventListener('click', (e) => {
    e.preventDefault();
    if (!desktopMenuBreakpoint.matches) {
      closeMenu();
    }
  });
});
